const INITIAL_STATE = {
    list: [],
    unread: 0,
    startIn: 0
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'USER_NOTIFICATION_UNREAD':
            return { ...state, unread: action.payload }
        case 'USER_NOTIFICATION_UNREAD_ADD':
            return { ...state, unread: action.payload + state.unread }
        case 'USER_NOTIFICATION_LIST': {
            // let list = action.payload.concat(state.list)
            // return { ...state, list }        
            return { ...state, list: [...state.list, ...action.payload] }
        }
        case 'USER_NOTIFICATION_READED': {
            var newList = state.list
            newList[action.payload].status = 'read'
            return { ...state,
                        unread: state.unread - 1,
                        list: newList
                    }
        }
        case 'USER_NOTIFICATION_LAST':
            return { ...state, startIn: action.payload }
        case 'USER_NOTIFICATION_CLEAR': 
            return { ...state, startIn: 0, unread: 0, list: [] }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/userNotificationsReducer.js